import { css } from 'styled-components';
import { COLORS } from '../../../../shared/design/tokens';
import {DEFAULT_VALUE_SUMMARY} from "../InstancesConfiguration/InstancesConfiguration";

const styles = {
  container: css`
    width: 100%;
    padding: 20px;
  `,
  titleContainer: css`
    margin-bottom: 12px;
  `,
  divider: css`
    box-sizing: border-box;
    height: 1px;
    width: 100%;
    border-bottom: 1px solid ${COLORS.DIVIDER.BORDER};
    margin-bottom: 19px;
  `,
  sectionRow: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `,
  sumSectionContainer: css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: ${({ removeTopPadding }) =>
      removeTopPadding ? '0px' : '24px'};
    margin-bottom: 20px;
  `,
  totalSectionContainer: css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 19px;
  `,
  labelContainer: css`
    width: 140px;
    line-height: 26px;
    margin-top: 5px;
  `,
  valueContainer: css`
    width: 200px;
    word-wrap: break-word;
    ${({ multiLine }) => {
      if (multiLine)
        return css`
          text-overflow: ellipsis;
          display: flex;
          flex-direction: column;
        `;
      return css`
        width: 200px;
        overflow: hidden;
        white-space: nowrap;
        -ms-text-overflow: ellipsis;
        text-overflow: ellipsis;
      `;
    }}
  `,
  label: css`
    color: ${COLORS.TEXT.LIGHT_GRAY};
  `,
  value: css`
    text-align: left;
    color: ${({ children }) => children === DEFAULT_VALUE_SUMMARY ? COLORS.TEXT.LIGHT_GRAY : null
  }

  `
};

export default styles;
